import React from 'react';

const SkipLinks: React.FC = () => {
  const handleSkipTo = (targetId: string, scrollBehavior: 'start' | 'center' = 'start') => {
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: scrollBehavior });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, targetId: string, scrollBehavior: 'start' | 'center' = 'start') => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSkipTo(targetId, scrollBehavior);
    }
  };

  return (
    <div className="skip-links">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        onClick={(e) => {
          e.preventDefault();
          handleSkipTo('main-content', 'start');
        }}
        onKeyDown={(e) => handleKeyDown(e, 'main-content', 'start')}
      >
        Skip to main content
      </a>
      <a
        href="#hero-search"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-32 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        onClick={(e) => {
          e.preventDefault();
          handleSkipTo('hero-search', 'center');
        }}
        onKeyDown={(e) => handleKeyDown(e, 'hero-search', 'center')}
      >
        Skip to search
      </a>
      <a
        href="#featured-properties"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-56 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        onClick={(e) => {
          e.preventDefault();
          handleSkipTo('featured-properties', 'start');
        }}
        onKeyDown={(e) => handleKeyDown(e, 'featured-properties', 'start')}
      >
        Skip to properties
      </a>
      <a
        href="#popular-locations"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-80 focus:z-50 focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        onClick={(e) => {
          e.preventDefault();
          handleSkipTo('popular-locations', 'start');
        }}
        onKeyDown={(e) => handleKeyDown(e, 'popular-locations', 'start')}
      >
        Skip to locations
      </a>
    </div>
  );
};

export default SkipLinks;